import { useEffect, useRef } from 'react';
import PanoramaInfoWidget from '../panoramaAddons/panoramaInfoWidget/PanoramaInfoWidget';
import { useAppSelector } from '../../../stateManagement/hooks/redux';
import { addButtonsToPano, changeFov, changeSources, changeViewAngle, controlCameraMove, getFrameAtPos, getNextFrame, getNextFrameForVideoPlay, parsePanoramaXML } from '../panoramaFeatures/panoramaFunctions/panoramaFunctions';
import { setPanoramaCurrentFOV, setPanoramaCurrentHLookAngle, setPanoramaCurrentVLookAngle, setPanoramaWindowIsLoading, setPanoramaXMLIsRendering } from '../../../stateManagement/reducers/PanoramaSlice';
import { useDispatch } from 'react-redux';
import { panoramaApiSlice } from '../../../api/rtk/base/slices/panoramaApiSlice';
import { setItemWebStorage } from '../../../features/webStorageSaver';
import ToastMessageContainer from '../../toastMessageContainer/ToastMessageContainer';

const emptyXML = require('../../../assets/krpano/emptyPanoramaLayer.xml')

export default function PanoramaWidget({ panoramaSizeClass, showPanoramaInfoWidget = true }: any) {
    const dispatch = useDispatch()
    const panoramaRef = useRef<any>(null)
    const panoramaDom: any = document.getElementById('panorama');
    let windowObject: any = window
    const xml = useAppSelector(state => state.panorama.xml)
    const { xmlChangeMarker, panoramaVideoIsPlaying, panoramaXMLIsRendering, videoCurrentDirection, panoramaCurrentHLookAngle, panoramaCurrentVLookAngle, panoramaCurrentFOV } = useAppSelector(state => state.panorama)

    const [fetchNextFrameQuery] = panoramaApiSlice.useLazyFetchNextFrameQuery();
    const [fetchFastNextFrameQuery] = panoramaApiSlice.useLazyFetchFastNextFrameQuery();

    // Функция слушатель угла поворота камеры в панораме
    windowObject.adapterKrPanoOnHLookAtChange = async () => {
        if (panoramaDom && xml) {
            let hLookAngle = panoramaDom.get("view.hlookat")
            let vLookAngle = panoramaDom.get("view.vlookat")
            let fov = panoramaDom.get("view.fov")
            dispatch(setPanoramaCurrentHLookAngle(hLookAngle))
            dispatch(setPanoramaCurrentVLookAngle(vLookAngle))
            dispatch(setPanoramaCurrentFOV(fov))
            setItemWebStorage('panoramaHAngle', hLookAngle)
            setItemWebStorage('panoramaVAngle', vLookAngle)
            setItemWebStorage('panoramaFOV', fov)
        }
    }

    // Функция для поиска следующего кадра
    windowObject.getNextFrame = async (direction: any) => {
        getNextFrame(direction, fetchNextFrameQuery)
    }
    // Функция для поиска далекого следующего кадра
    windowObject.getFrameAtPos = async (direction: any) => {
        getFrameAtPos(direction, fetchFastNextFrameQuery)
    }
    // Функция для начала движения камеры
    windowObject.playPanorama = async (direction: any) => {
        controlCameraMove(direction, panoramaVideoIsPlaying)
    }
    // Функция для обозначения окончания загрузки панорамы
    windowObject.adapterKrPanoOnComplete = async () => {
        dispatch(setPanoramaXMLIsRendering(false))
        dispatch(setPanoramaWindowIsLoading(false))
    }

    // Заполнение панорамы
    useEffect(() => {
        try {
            let xmlTemp = xml
            // Редактирование приходящего xml с последующим созданием панорамы
            if (xmlTemp) {
                xmlTemp = addButtonsToPano(xmlTemp)
                xmlTemp = changeSources(xmlTemp)
                xmlTemp = changeViewAngle(xmlTemp, panoramaCurrentHLookAngle, panoramaCurrentVLookAngle, panoramaCurrentFOV)
                xmlTemp = changeFov(xmlTemp)
                parsePanoramaXML(xmlTemp)
                if (panoramaDom) {
                    panoramaDom.call(`loadxml(${xmlTemp}, null ,null, BLEND(0.05))`)
                } else {
                    var settings: any = {}
                    settings["onstart"] = `loadxml(${xmlTemp}, null ,null, BLEND(0.05))`;
                    window.embedpano({
                        focus: true,
                        html5: "only",
                        id: 'panorama',
                        target: panoramaRef.current,
                        vars: settings,
                        xml: emptyXML,
                        webgl: "true",
                    });
                }
            }
            else {
                let panoramaElement: any = document.getElementById('panorama');
                if (panoramaElement) {
                    panoramaElement.parentNode.removeChild(panoramaElement);
                }
                window.embedpano({
                    focus: true,
                    html5: "only",
                    id: 'panorama',
                    target: panoramaRef.current,
                    xml: emptyXML,
                    webgl: "true",
                });
            }
        } catch (error: any) {
            console.error("Ошибка:", error.message);
        }
    }, [xmlChangeMarker])

    useEffect(() => {
        if (panoramaVideoIsPlaying && !panoramaXMLIsRendering) {
            getNextFrameForVideoPlay('panorama', videoCurrentDirection, fetchNextFrameQuery)
        }
    }, [panoramaVideoIsPlaying, videoCurrentDirection, panoramaXMLIsRendering])

    return (
        <>
            <ToastMessageContainer windowType='panorama'/>
            <div ref={panoramaRef} className={panoramaSizeClass ? panoramaSizeClass : "full-size-panorama-widget" + (showPanoramaInfoWidget ? ' with-info-widget' : '')} />
            <PanoramaInfoWidget />
        </>
    )
}
